import InfoIcon from '@mui/icons-material/Info'
import { Box, Paper, Stack, Typography, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

import { i18WithDefault as t } from '@shared/locales'
import {
  CustomOrderPaymentAdminDto,
  CustomOrderPaymentClientDto,
  OrderAdminDto,
  OrderClientDto,
  ReceiptDto,
} from 'service-api/src/types/api'
import { DetailsSection } from './receipt_details/DetailsSection'
import { Footer } from './receipt_details/Footer'
import { Header } from './receipt_details/Header'
import { OffersSection } from './receipt_details/OffersSection'
import { RequestDates, TReceiptInvoice } from './request_dates'

export const PurchaseReceipt = ({
  receipt,
  dueToday,
  isVisit,
  order,
}: {
  receipt?: ReceiptDto
  dueToday?: number | null
  isVisit?: boolean
  order?: OrderClientDto | OrderAdminDto
  surchargeValues?: CustomOrderPaymentAdminDto['surcharge'] | CustomOrderPaymentClientDto['surcharge']
}) => {
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return receipt ? (
    <Box>
      <Paper sx={{ p: 2, height: '100%', borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
        <Header name={receipt.locationName} address={receipt.locationAddress} phone={receipt.locationPhone} />
        <RequestDates invoices={(receipt.invoices || []) as unknown as TReceiptInvoice[]} />
        <DetailsSection receipt={receipt} isVisit={isVisit} />
        <Stack px={1}>
          <OffersSection receipt={receipt} />
          <Footer receipt={receipt} dueToday={dueToday} order={order!} />
        </Stack>
      </Paper>
      {receipt.invoices?.some((invoice) => invoice.items?.some((item) => item.priceVaries)) && (
        <Stack direction="row" spacing={1} mt={1}>
          <InfoIcon
            sx={{
              width: '20px',
              height: '20px',
              color: theme.palette.action.active,
            }}
          />
          <Typography>{t('booking.startingAtPolicy')}</Typography>
        </Stack>
      )}
    </Box>
  ) : null
}
